import { useShallow } from "zustand/react/shallow"

import AddPhoneNumberModal from "./addPhoneNumberModal/AddPhoneNumberModal"
import DownloadMobileAppModal from "./DownloadMobileAppModal"
import FreeTrialFirstVerifyModal from "./FreeTrialFirstVerifyModal"
import FreeTrialLimitModal from "./FreeTrialLimitModal"
import { ImageModal } from "./ImageModal"
import ManageScreenTimeFTUXModal from "./ManageScreenTimeFTUXModal"
import SetUpChildFTUXModal from "./SetUpChildFTUXModal"
import WelcomeModal from "./WelcomeModal"
import DataTaskCompletionModal from "../../pages/academy/dataTasks/DataTaskCompletionModal"
import DataTasksModal from "../../pages/academy/dataTasks/DataTasksModal"
import TrainingModal from "../../pages/academy/training/TrainingModal"
import CoachUpsellModal from "../../pages/care/CoachUpsellModal"
import LinkTherapistModal from "../../pages/care/therapists/LinkTherapistModal"
import {
  ManageTherapistModal,
  useManageTherapistModalStore,
} from "../../pages/care/therapists/ManageTherapistModal"
import UnpauseConfirmationModal from "../../pages/coach/overlays/UnpauseConfirmationModal"
import PlanUpdateModal from "../../pages/coach/planUpdate/PlanUpdateModal"
import SessionBookingModal from "../../pages/coach/sessions/SessionBookingModal"
import DoterChatModal from "../../pages/family/childUser/DoterChatModal"
import CoinTransactionsModal from "../../pages/family/coinTransactions/CoinTransactionsModal"
import GetChildStarted from "../../pages/family/GetChildStartedModal"
import DoterAIInfoModal from "../../pages/family/manageGameplay/doterChat/DoterAIInfoModal"
import SelectGiftModal from "../../pages/family/parentUser/mailbox/InventoryGiftShopModal"
import SendMessageModal from "../../pages/family/parentUser/mailbox/SendMailModal"
import ParentPasscodeModal from "../../pages/family/parentUser/parentPasscodeModal/ParentPasscodeModal"
import CatchUp from "../../pages/me/CatchUp"
import IncidentReport from "../../pages/me/incidents/IncidentReport"
import ParentTasksModal from "../../pages/me/parentTasks/ParentTasksModal"
import TaskReflectionModal from "../../pages/me/parentTasks/TaskReflectionModal"
import PrivacyPolicyUpdateModal from "../../pages/me/privacyPolicyUpdate/PrivacyPolicyUpdateModal"
import StripeCheckoutModal from "../../pages/paywall/StripeCheckoutModal"
import AddEditQuestModal from "../../pages/questBoard/addEditQuestModal/AddEditQuestModal"
import { useAddEditQuestStore } from "../../pages/questBoard/addEditQuestModal/useAddEditQuestStore"
import AddQuestTemplatesModal from "../../pages/questBoard/addQuestTemplates/AddQuestTemplatesModal"
import { useAddQuestTemplatesModalStore } from "../../pages/questBoard/addQuestTemplates/useAddQuestTemplatesModalStore"
import AllQuestsModal from "../../pages/questBoard/allQuests/AllQuestsModal"
import FirstQuestCompleteModal from "../../pages/questBoard/FirstQuestCompleteModal"
import QuestAIModal from "../../pages/questBoard/questAI/QuestAIModal"
import QuestReviewModal from "../../pages/questBoard/questReview/QuestReviewModal"
import ReviewQuestModal from "../../pages/questBoard/ReviewQuestModal"
import { QuestActionsModal } from "../../pages/questBoard/viewQuestModal/QuestActionsModal"
import QuestModal from "../../pages/questBoard/viewQuestModal/ViewQuestModal"
import AddEditRewardModal from "../../pages/rewards/AddEditRewardModal"
import BonusRewardModal from "../../pages/rewards/BonusRewardModal"
import DeductCoinsModal from "../../pages/rewards/DeductCoinsModal"
import DeleteRewardModal from "../../pages/rewards/DeleteRewardModal"
import useAddEditRewardModalStore from "../../pages/rewards/hooks/useAddEditRewardModalStore"
import PurchaseRewardModal from "../../pages/rewards/PurchaseRewardModal"
import AutoApproveSettingsModal from "../../pages/rewards/redeem/AutoApproveSettingsModal"
import FilterRewardLogsModal from "../../pages/rewards/redeem/FilterRewardLogsModal"
import { RedemptionSuccessModal } from "../../pages/rewards/redeem/RedemptionSuccessModal"
import RewardQuantityModal from "../../pages/rewards/redeem/RewardQuantityModal"
import { ScreenTimeControlsModal } from "../../pages/rewards/redeem/ScreenTimeControlsModal"
import ScreenTimeRestrictionsConfirmationModal from "../../pages/rewards/redeem/ScreenTimeRestrictionsConfirmationModal"
import ScreenTimeRestrictionsModal from "../../pages/rewards/redeem/ScreenTimeRestrictionsModal"
import ToggleScreenTimeRestrictionsModal from "../../pages/rewards/redeem/ToggleScreenTimeRestrictionsModal"

const ModalProvider = () => {
  const isOpenAddRewards = useAddEditRewardModalStore(
    useShallow((state) => state.isOpen)
  )
  const isOpenAddQuestTemplates = useAddQuestTemplatesModalStore(
    useShallow((state) => state.isOpen)
  )
  const isOpenAddEditQuest = useAddEditQuestStore(
    useShallow((state) => state.isOpen)
  )
  const isOpenManageTherapist = useManageTherapistModalStore(
    useShallow((state) => state.isOpen)
  )
  return (
    <>
      <CatchUp />
      <AddPhoneNumberModal />
      <DownloadMobileAppModal />
      <QuestModal />
      <QuestActionsModal />
      <ReviewQuestModal />
      <AllQuestsModal />
      {isOpenAddQuestTemplates && <AddQuestTemplatesModal />}
      <FreeTrialLimitModal />
      <FreeTrialFirstVerifyModal />
      <GetChildStarted />
      {isOpenAddRewards && <AddEditRewardModal />}
      {isOpenManageTherapist && <ManageTherapistModal />}
      <BonusRewardModal />
      <DeductCoinsModal />
      <CoinTransactionsModal />
      {isOpenAddEditQuest && <AddEditQuestModal />}
      <ImageModal />
      <QuestReviewModal />
      <FirstQuestCompleteModal />
      <DeleteRewardModal />
      <PurchaseRewardModal />
      <RewardQuantityModal />
      <AutoApproveSettingsModal />
      <FilterRewardLogsModal />
      <IncidentReport />
      <TrainingModal />
      <CoachUpsellModal />
      <PlanUpdateModal />
      <UnpauseConfirmationModal />
      <ParentTasksModal />
      <DataTasksModal />
      <TaskReflectionModal />
      <DataTaskCompletionModal />
      <SessionBookingModal />
      <ParentPasscodeModal />
      <ScreenTimeControlsModal />
      <ScreenTimeRestrictionsModal />
      <ScreenTimeRestrictionsConfirmationModal />
      <ToggleScreenTimeRestrictionsModal />
      <RedemptionSuccessModal />
      <QuestAIModal />
      <DoterAIInfoModal />
      <DoterChatModal />
      <LinkTherapistModal />
      <WelcomeModal />
      <ManageScreenTimeFTUXModal />
      <SetUpChildFTUXModal />
      <SelectGiftModal />
      <SendMessageModal />
      <PrivacyPolicyUpdateModal />
      <StripeCheckoutModal />
    </>
  )
}

export default ModalProvider
